import { DataLayerItem, Item } from "./types"

export function getDataLayerItem(
  item: DataLayerItem,
  quantity: number,
  index: number
): Item {
  return {
    item_id: item.id,
    item_name: item.name,
    currency: "EUR",
    index,
    item_brand: "Choices by DL",
    item_category: "Apparel & Accessories",
    item_category2: "Jewelry",
    item_list_id: "related_products",
    item_list_name: "Related Products",
    price: Math.round((item.price / 121) * 100) / 100,
    quantity,
  }
}
